import * as t from "./actionType";

// ---------- RECORDING ----------
export const meetingRecordingList = (data) => ({
  type: t.MEETING_RECORDING_LIST,
  data,
});
export const meetingRecordingListSuccess = (data) => ({
  type: t.MEETING_RECORDING_LIST_SUCCESS,
  data,
});
export const meetingRecordingListFail = (data) => ({
  type: t.MEETING_RECORDING_LIST_FAIL,
  data,
});

export const meetingRecordingData = (data) => ({
  type: t.MEETING_RECORDING_DATA,
  data,
});
export const meetingRecordingDataSuccess = (data) => ({
  type: t.MEETING_RECORDING_DATA_SUCCESS,
  data,
});
export const meetingRecordingDataFail = (data) => ({
  type: t.MEETING_RECORDING_DATA_FAIL,
  data,
});

export const meetingRecordingDispatch = (data) => ({
  type: t.MEETING_RECORDING_DISPATCH,
  data,
});
export const meetingRecordingDispatchSuccess = (data) => ({
  type: t.MEETING_RECORDING_DISPATCH_SUCCESS,
  data,
});
export const meetingRecordingDispatchFail = (data) => ({
  type: t.MEETING_RECORDING_DISPATCH_FAIL,
  data,
});
export const meetingRecordingDispatchReset = () => ({
  type: t.MEETING_RECORDING_DISPATCH_RESET,
});

export const meetingRecordingUpdate = (data) => ({
  type: t.MEETING_RECORDING_UPDATE,
  data,
});
export const meetingRecordingUpdateSuccess = (data) => ({
  type: t.MEETING_RECORDING_UPDATE_SUCCESS,
  data,
});
export const meetingRecordingUpdateFail = (data) => ({
  type: t.MEETING_RECORDING_UPDATE_FAIL,
  data,
});
export const meetingRecordingUpdateReset = () => ({
  type: t.MEETING_RECORDING_UPDATE_RESET,
});

export const meetingRecordingDelete = (data) => ({
  type: t.MEETING_RECORDING_DELETE,
  data,
});
export const meetingRecordingDeleteSuccess = (data) => ({
  type: t.MEETING_RECORDING_DELETE_SUCCESS,
  data,
});
export const meetingRecordingDeleteFail = (data) => ({
  type: t.MEETING_RECORDING_DELETE_FAIL,
  data,
});
export const meetingRecordingDeleteReset = () => ({
  type: t.MEETING_RECORDING_DELETE_RESET,
});

export const meetingRecordingRetrySummary = (id) => ({
  type: t.MEETING_RECORDING_RETRY_SUMMARY,
  data: id,
});
export const meetingRecordingRetrySummarySuccess = (data) => ({
  type: t.MEETING_RECORDING_RETRY_SUMMARY_SUCCESS,
  data,
});
export const meetingRecordingRetrySummaryFail = (data) => ({
  type: t.MEETING_RECORDING_RETRY_SUMMARY_FAIL,
  data,
});
export const meetingRecordingRetrySummaryReset = () => ({
  type: t.MEETING_RECORDING_RETRY_SUMMARY_RESET,
});

export const meetingRecordingSync = (id) => ({
  type: t.MEETING_RECORDING_SYNC,
  data: id,
});
export const meetingRecordingSyncSuccess = (data) => ({
  type: t.MEETING_RECORDING_SYNC_SUCCESS,
  data,
});
export const meetingRecordingSyncFail = (data) => ({
  type: t.MEETING_RECORDING_SYNC_FAIL,
  data,
});
export const meetingRecordingSyncReset = () => ({
  type: t.MEETING_RECORDING_SYNC_RESET,
});

// ---------- SETTINGS ----------
export const meetingRecordingSettings = (data) => ({
  type: t.MEETING_RECORDING_SETTINGS,
  data,
});
export const meetingRecordingSettingsSuccess = (data) => ({
  type: t.MEETING_RECORDING_SETTINGS_SUCCESS,
  data,
});
export const meetingRecordingSettingsFail = (data) => ({
  type: t.MEETING_RECORDING_SETTINGS_FAIL,
  data,
});

export const meetingRecordingSettingsUpdate = (data) => ({
  type: t.MEETING_RECORDING_SETTINGS_UPDATE,
  data,
});
export const meetingRecordingSettingsUpdateSuccess = (data) => ({
  type: t.MEETING_RECORDING_SETTINGS_UPDATE_SUCCESS,
  data,
});
export const meetingRecordingSettingsUpdateFail = (data) => ({
  type: t.MEETING_RECORDING_SETTINGS_UPDATE_FAIL,
  data,
});
export const meetingRecordingSettingsUpdateReset = () => ({
  type: t.MEETING_RECORDING_SETTINGS_UPDATE_RESET,
});
